import Icon from "@material-ui/icons/AssignmentTurnedIn";
import AssignmentList from "./AssignmentList";
import AssignmentShow from "./AssignmentShow";
import AssignmentEdit from "./AssignmentEdit";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "assignments",
  list: AssignmentList,
  show: AssignmentShow,
  edit: AssignmentEdit,
  icon: Icon,
};
